import Component from '@galactic-advisors/component-loader';
import axios from 'axios';

const DEFAULTS = {
  continueButtonElement: '[data-continue-button]',
  disclaimerContainerElement: '[data-disclaimer-container]',
  modalFooterElement: '[data-modal-footer]',
  m365DomainEditButton: '[data-m365-domain-edit-button]',
  m365TenantDomainTextElement: '[data-m365-tenant-domain]',
  m365EditTenantDomainTextInputElement: '[data-m365-edit-tenant-domain-input]',
  m365EditTenantDomainTextContainerElement:
    '[data-m365-edit-tenant-domain-input-container]',
  m365EditTenantDomainTextSubmitButtonElement:
    '[data-m365-edit-tenant-domain-input-submit-button]',
  toastMessageContainerElement: '[data-toast-message-container]',
  toastMessageElement: '[data-toast-message]',
  tableContainerElement: '[data-table-container]',
  loaderElement: '[data-loader]',
};

export default class M365AuthModal extends Component {
  static selector = '[data-comp-m365-auth-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.m365DomainEditButton = this.$container.querySelector(
      this.$options.m365DomainEditButton
    );

    this.m365TenantDomainText = this.$container.querySelector(
      this.$options.m365TenantDomainTextElement
    );

    this.m365EditTenantDomainInput = this.$container.querySelector(
      this.$options.m365EditTenantDomainTextInputElement
    );

    this.m365EditTenantDomainTextContainer = this.$container.querySelector(
      this.$options.m365EditTenantDomainTextContainerElement
    );

    this.m365EditTenantDomainTextSubmitButton = this.$container.querySelector(
      this.$options.m365EditTenantDomainTextSubmitButtonElement
    );

    this.continueButton = this.$container.querySelector(
      this.$options.continueButtonElement
    );

    this.modalFooter = this.$container.querySelector(
      this.$options.modalFooterElement
    );

    this.disclaimerContainer = this.$container.querySelector(
      this.$options.disclaimerContainerElement
    );

    this.tableContainer = this.$container.querySelector(
      this.$options.tableContainerElement
    );

    this.toastMessageContainer = this.$container.querySelector(
      this.$options.toastMessageContainerElement
    );

    this.toastMessage = this.$container.querySelector(
      this.$options.toastMessageElement
    );

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.initListeners();
  }

  async submitEdit() {
    const formData = {
      m365_tenant_domain: this.m365EditTenantDomainInput.value,
    };

    return axios
      .post(
        this.m365TenantDomainText.dataset.m365TenantDomainUpdateRoute,
        formData
      )
      .then((response) => response)
      .catch((error) => {
        this.toastMessageContainer.classList.remove('d-none');
        this.toastMessage.innerText = 'Failed To Update Tenant Domain!';
        setTimeout(() => {
          this.toastMessageContainer.classList.add('d-none');
        }, 1000);
        console.error(error);
      });
  }

  updateTenantDomainText() {
    this.m365TenantDomainText.innerText = this.m365EditTenantDomainInput.value;
    this.toastMessageContainer.classList.remove('d-none');
    this.toastMessage.innerText = 'Successfully Updated Tenant Domain!';
    this.m365EditTenantDomainTextContainer.classList.add('d-none');
    this.loader.classList.add('d-none');
    setTimeout(() => {
      this.toastMessageContainer.classList.add('d-none');
      this.m365TenantDomainText.classList.remove('d-none');
      this.m365DomainEditButton?.classList.remove('d-none');
    }, 3000);
  }

  initListeners() {
    this.m365DomainEditButton?.addEventListener('click', () => {
      this.m365TenantDomainText.classList.add('d-none');
      this.m365DomainEditButton?.classList.add('d-none');
      this.m365EditTenantDomainTextContainer.classList.remove('d-none');
    });

    this.m365EditTenantDomainTextSubmitButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.loader.classList.remove('d-none');
        this.submitEdit().then(() => this.updateTenantDomainText());
      }
    );

    this.continueButton?.addEventListener('click', (event) => {
      event.preventDefault();

      this.disclaimerContainer.classList.add('d-none');
      this.tableContainer.classList.remove('d-none');
      this.modalFooter.classList.remove('d-none');
      this.modalFooter.classList.add('d-inline-flex');
    });
  }
}
